import { TimeFrames } from '../model/types';

export const getTimeFrames = (width: number): TimeFrames => {
    const isTide = width <= 500;

    return [
        { value: '3m', label: isTide ? '3 мес.' : '3 месяца' },
        { value: '6m', label: isTide ? '6 мес.' : '6 месяцев' },
        { value: 'y', label: 'Год' },
        { value: 'all', label: 'Все время' },
    ];
};
